import { Application, Controller } from "@hotwired/stimulus";

class NftAccessController extends Controller {
  static targets = ['accessLink']

  connect() {
    if (!this.hasAccessLinkTarget) return;
    
    this.accessLinkTarget.addEventListener('click', this.disableLink.bind(this));
  }

  disableLink() {
    this.accessLinkTarget.classList.add("disabled");
  }
}

// Registered in admin.js
export { NftAccessController };
